
import { Component, Vue, Watch, Prop } from "vue-property-decorator"

// import api from "@/services/api"
import { Case } from "@/types/case"
import CaseFile from "@/types/caseFile"

@Component({
	components: {
	}
})
export default class UniqueCaseNumber extends Vue {

}
